import http from "@/settings/apiSettings"

class CrmOferteDataService {
    save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/CRM_Oferte", data);
    }

    revise(key: string, data: any): Promise<any> {
        return http.clientComercialOdata.post(`/CRM_Oferte(${key})/Revise`, data);
    }

    listFiles(ofertaId: string) {
        return http.clientComercialUpload.get(`/crm/oferte/${ofertaId}/files`, {
            headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") },
        });
    }

    uploadFile(ofertaId: string, file: File) {
        const fd = new FormData();
        fd.append("file", file);
        return http.clientComercialUpload.post(`/crm/oferte/${ofertaId}/files`, fd, {
            headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") },
        });
    }

    downloadFile(fileId: string) {
        return http.clientComercialUpload.get(`/crm/oferte/files/${fileId}`, {
            responseType: "blob",
            headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") },
        });
    }

    deleteFile(fileId: string) {
        return http.clientComercialUpload.delete(`/crm/oferte/files/${fileId}`, {
            headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") },
        });
    }

    replaceFile(fileId: string, file: File) {
        const fd = new FormData();
        fd.append("file", file);
        return http.clientComercialUpload.put(`/crm/oferte/files/${fileId}`, fd, {
            headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") },
        });
    }
}
export default new CrmOferteDataService();